<template>
    <v-content style="height: 100%">
        <Header></Header>

        <v-layout justify-center style="padding-top: 160px;">
            <v-flex xs11 md10>

                <v-layout justify-center mb-5>
                    <v-flex shrink class="txt-head">
                        {{ $t('page.confirmation.title') }}
                    </v-flex>
                </v-layout>

                <v-card class="mb-7">
                    <v-layout justify-center pa-7>
                        <v-flex md10>
                            <div class="txt-semi-head font-weight-bold mb-5">
                                {{ $t('general.room') }}
                                {{ room.name }}
                                {{ $t('page.home.roomOffer.roomTypePrefix') }}
                                {{ room.room_type.name }}
                                {{ $t('general.level') }}
                                {{ room.level.name }}
                                {{ $t('general.building') }}
                                {{ room.building.name }}
                            </div>

                            <!-- Room type gallery -->
                            <v-carousel class="mb-5">
                                <v-carousel-item
                                    v-for="(item, index) in room.room_type.gallery"
                                    :key="index"
                                    :src="item.image"></v-carousel-item>
                            </v-carousel>

                            <div class="txt-semi-head mb-5">{{ $t('page.roomSelect.roomDesign') }} : {{ room.room_type.data_object[`design_${language}`] }}</div>
                            <div class="txt-semi-head mb-5">{{ $t('page.roomSelect.roomSize') }} : {{ room.size }} {{ $t('page.roomSelect.sqm') }}</div>
                            <!--<div class="txt-semi-head mb-5">{{ $t('page.roomSelect.roomView') }} : {{ room[`view_${language}`] }}</div>-->
                            <div class="txt-head centro-darkcolor mb-5">
                                {{ $t('general.price') }}
                                {{ room.price | numberFormat }}
                                {{ $t('general.baht') }}
                            </div>

                            <template v-if="room.promotion">
                                <div class="txt-semi-head font-weight-bold mb-5">{{ $t('page.roomSelect.promotionDescription') }} : {{ room.promotion.data_object[language] }}</div>
                            </template>
                            <div class="txt-semi-head mb-5">{{ $t('page.roomSelect.reserveText') }} {{ room.reserve_price | numberFormat }} {{ $t('general.baht') }}</div>
                            <v-divider style="border-color: #000" class="my-5"></v-divider>
                            <div class="txt-semi-head mb-5">{{ $t('form.name') }} {{ reservationForm.name }} {{ reservationForm.surname }}</div>
                            <div class="txt-semi-head mb-5">{{ $t('form.tel') }} {{ reservationForm.tel }}</div>
                            <div class="txt-semi-head mb-5">{{ $t('form.email') }} {{ reservationForm.email }}</div>
                        </v-flex>
                    </v-layout>
                </v-card>

                <v-layout
                    justify-center mb-7
                    class="align-center text-center flex-wrap"
                    :column="$vuetify.breakpoint.xs">
                    <v-btn
                        @click="$router.go(-1)"
                        large
                        width="280"
                        style="border: solid 1px #C4C4C4"
                        class="mr-2 mb-2">{{ $t('general.cancel') }}</v-btn>
                    <v-btn
                        @click="reserveRoomHandler"
                        large
                        color="primary"
                        width="280"
                        style="border: solid 1px #C4C4C4"
                        class="mb-2">{{ $t('general.pay') }}</v-btn>
                </v-layout>

                <v-layout justify-center mb-7>
                    <img :src="require('../assets/payment.png')">
                </v-layout>

            </v-flex>
        </v-layout>

        <form :action="paymentRequest.payment_url" ref="paymentForm" method="POST">
            <input type="hidden" name="version" :value="paymentRequest.version" />
            <input type="hidden" name="merchant_id" :value="paymentRequest.merchant_id" />
            <input type="hidden" name="currency" :value="paymentRequest.currency" />
            <input type="hidden" name="result_url_1" :value="paymentRequest.result_url_1" />
            <input type="hidden" name="hash_value" :value="paymentRequest.hash_value" />
            <input type="hidden" name="payment_description" :value="paymentRequest.payment_description" />
            <input type="hidden" name="order_id" :value="paymentRequest.order_id" />
            <input type="hidden" name="amount" :value="paymentRequest.amount" />
            <input type="submit" ref="paymentFormSubmitButton" class="d-none">
        </form>

        <Footer></Footer>
    </v-content>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import Service from '../services';
    import {mapState, mapActions} from 'vuex'

    export default {
        name: "Confirmation",
        components: {
            Header,
            Footer
        },
        computed: {
            ...mapState({
                room: state => state.roomSelected.room,
                reservationForm: state => state.reservation.reservationForm,
                language: state => state.locale.language
            }),
        },
        data: () => ({
            paymentRequest: {}
        }),
        created() {
            this.recordedSender()
        },
        methods: {
            ...mapActions('reservation', ['reserveRoom', 'clearReservationForm']),
            ...mapActions('roomSelected', ['onClearBooking']),
            async reserveRoomHandler () {
                const reservation = await this.reserveRoom(this.language)
                // await this.onClearBooking()

                // return this.$router.replace(`/show-invoice/${reservation.id}`)

                this.paymentRequest = await Service.reservation.getReservationPaymentRequest(reservation.id, this.language)
                
                this.$nextTick(() => {
                    this.$refs.paymentFormSubmitButton.click()
                })

                await this.clearReservationForm()
            },
            recordedSender () {
                let data = {
                    user_activity_type_id: 1,
                    uuid: Math.random().toString(36).substring(5, 10) + '-' + Math.random().toString(36).substring(5, 10) + '-' + Math.random().toString(36).substring(5, 10),
                    value: this.$route.path
                };
                // console.log(data)
                Service.record.sendActivityData(data)
            }
        }
    }
</script>

<style scoped>

</style>